module.exports = function getResource(label, vars = []) {
    let resources = {
        onlyFewLeftCopy: 'Plus que quelques articles en stock'
    };

    return resources[label];
};
